import { Tab, Tabs } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';
import { useDispatch, useSelector } from 'react-redux';
import { ExpandCollapseAccordionGeneral } from './GeneralAccordion';
import InputGroup from 'react-bootstrap/InputGroup';
import Form from 'react-bootstrap/Form';
import { useEffect, useState, useRef } from 'react';
import $ from "jquery";
import { getFinancialStatementAction, GetFinancialInvestmentsDropdownAction } from '../../actions/assetFinancialStatement';
import { InsertorUpdateStatement, getFinancialInvestmentsDropdown,InsertFinancialInvestmentTotal, CheckExistsFinancialStatementInvestment, DeleteNonVerifiedSecurities, Deletenonverifiedstatement, InsertSecurity, getSecuritiesAPI } from "../../../config/apiConfig";
import { sbaAxios } from "../../utils/sbaAxios";
import { Modal } from 'react-bootstrap';
import { SBAComboBox } from "../../UiComponents/SBADropDown";
import { toast } from 'react-toastify';
import { SBNotify } from '../../utils/sbNotify';
import { AutoComplete } from "@progress/kendo-react-dropdowns";

const FormatNumber = (num) => {
    if (num != undefined) {
        return num.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })
    }
}

const RemoveThousandSep = (num) => {
    if (num != undefined)
        return parseFloat(num.replace(/,(?=\d{3})/g, ''));
    else
        return 0;
}
// Formatting the number using thousand separators
const ThousandsSeparators = (num) => {
    if (num != undefined) {
        let num_parts = num.toString().split(".");
        num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return num_parts.join(".");
    }
}


const GetTotalNetAsset = (FinancialTotals) => {
    let totalAsset = FinancialTotals?.find(element => element.FinancialStatementTypeId === 1)?.FinancialStatementTypeTotal || 0;
    let totalLiabilities = FinancialTotals?.find(element => element.FinancialStatementTypeId === 2)?.FinancialStatementTypeTotal || 0;
    return totalAsset - totalLiabilities;
}

const GetNotionalAmount = (FinancialDetails, notionalStatementId) => {
    return FinancialDetails?.find(element => element.FinancialStatementId == notionalStatementId).Value;
}




export function FinancialStatementtab({ tabData, setTabData, setActiveTab, activeTab, AssetId, AssetYear, saveData }) {
    const [financial, setFinancialData] = useState(tabData);
    const Gstate = useSelector((state) => { return state }) || {};

    useEffect(() => {
        // document.addEventListener("custom:save", SaveResults);
        // document.addEventListener("custom:reload", ReloadData);
        setFinancialData(tabData);
    }, [tabData]);
    const tabs = financial.FinancialStatementTabs;
    let FinancialDetails = financial.FinancialDetails;
    //const [FinancialDetails, setFinancialDetails] = useState();
    const section = financial.FinancialStatementSections;
    let FinancialStatementsTypesTotals = financial.FinancialStatementsTypesTotals;
    let FinancialStInvestData = financial?.FinancialInvestmentDetail;
    const FinancialStTypes = financial.FinancialStatementTypes;

    let FSValuesUpdated = useRef();
    let FSTotalsUpdated = useRef();
    let FSInvestmentsUpdated = useRef();
    let FSInvestmentsTotalsUpdated = useRef();



    const SaveResults = () => {
        // console.log("Fin Stmnts: " + FSValuesUpdated.current);
        // console.log("Fin Totals: " + FSTotalsUpdated.current);
        // console.log("Fin Inv: " + FSInvestmentsUpdated.current);
        // console.log("Fin Inv Totals: " + FSInvestmentsTotalsUpdated.current);      
    }

    const ReloadData = () => {
    };
    const HandleEditFinancialSummaryDetail = (financialStatementId, financialStatementTypeId, amount) => {
        const newFinancialDetails = FinancialDetails.map(lineItem => {
            if (lineItem.FinancialStatementId === financialStatementId) {
                return { ...lineItem, Value: amount }
            } else {
                return lineItem;
            }

        });

        FinancialDetails = newFinancialDetails;
        FSValuesUpdated.current = newFinancialDetails;
        CalculateFinancialTotal(financialStatementTypeId, newFinancialDetails);

    };

    const CalculateFinancialTotal = (financialStatementTypeId, newFinancialDetails) => {
        const newTotal = newFinancialDetails.filter(item => item.FinancialStatementTypeId == financialStatementTypeId).map(item => parseFloat(item.Value)).reduce((accum, curr) => accum + curr, 0);
        const newFinancialTotals = FinancialStatementsTypesTotals.map(totItem => {
            if (totItem.FinancialStatementTypeId === financialStatementTypeId) {
                return { ...totItem, FinancialStatementTypeTotal: newTotal }
            }
            else {
                return totItem;
            }
        })
        FinancialStatementsTypesTotals = newFinancialTotals;
        FSTotalsUpdated.current = newFinancialTotals;;
    }

    const HandleEditInvestmentSummaryDetail = (financialStatementInvestmentId, financialStatementTypeId, amount) => {
        const newFinancialInvDetails = FinancialStInvestData.map(lineItem => {
            if (lineItem.FinancialStatementInvestmentId === financialStatementInvestmentId) {
                return { ...lineItem, InvestmentValue: amount }
            } else {
                return lineItem;
            }

        });

        FinancialStInvestData = newFinancialInvDetails;
        FSInvestmentsUpdated.current = newFinancialInvDetails;
        CalculateInvestmentTotal(financialStatementTypeId, newFinancialInvDetails);

    };

    const CalculateInvestmentTotal = (financialStatementTypeId, newInvestmentDetails) => {
        const newTotal = newInvestmentDetails.filter(item => item.FinancialStatementTypeId == financialStatementTypeId).map(item => parseFloat(item.InvestmentValue)).reduce((accum, curr) => accum + curr, 0);

        const newFinancialTotals = FinancialStatementsTypesTotals.map(totItem => {
            if (totItem.FinancialStatementTypeId === financialStatementTypeId) {
                return { ...totItem, FinancialStatementTypeTotal: newTotal }
            }
            else {
                return totItem;
            }
        })
        FinancialStatementsTypesTotals = newFinancialTotals;
        FSInvestmentsTotalsUpdated.current = newFinancialTotals;
    }



    const FormattedSections = section?.map(section => {
        const MatchingType = FinancialStTypes.find(function (type) {
            return (type.FinancialStatementSectionId == section.FinancialStatementSectionId);
        }) || { FinancialStatementTabId: 1 };
        return { ...section, TabID: MatchingType.FinancialStatementTabId };
    });



    const GeneralData = {

        AuditorDetails: financial?.AuditorDetails?.sort((a, b) =>
            a.AuditorName.localeCompare(b.AuditorName)) || [],
        IssuingOffice: financial?.IssuingOffice?.sort((a, b) =>
            a.OfficeName.localeCompare(b.OfficeName)) || [],
        AuditorId: financial?.AuditorId || 0,
        IssueDate: financial?.IssueDate || "",
        OpinionId: financial?.OpinionId || 0,
        AccountingStandardId: financial?.AccountingStandardId || 0,
        CurrencyId: financial?.CurrencyId || 0,
        IssuingOfficeId: financial?.IssuingOfficeId || 0,
        OwnershipInMF: financial?.OwnershipInMF || 0,
        IsCFTC: financial?.IsCFTC || false,
        IsMasterFeeder: financial?.IsMasterFeeder || false,
    } || {};



    const renderTab = (tab) => {
        switch (tab.FinancialStatementTabId) {
            case 1:
                return <div><StatementTab expandAllAccordian={true} FinancialStTypes={FinancialStTypes} FormattedSections={FormattedSections}
                    TabID={tab.FinancialStatementTabId} FinancialTotal={FinancialStatementsTypesTotals}
                    GeneralData={GeneralData} FinancialDetails={FinancialDetails}
                    onEdit={HandleEditFinancialSummaryDetail} setTabData={setTabData} tabData={tabData} assetId={AssetId} year={AssetYear} saveData={saveData} /></div>
            case 2:
                return <div><InvestmentTab FinancialStTypes={FinancialStTypes} FormattedSections={FormattedSections}
                    TabID={tab.FinancialStatementTabId} FinancialTotal={FinancialStatementsTypesTotals} financialStInvestData={FinancialStInvestData}
                    onEdit={HandleEditInvestmentSummaryDetail}
                    setTabData={setTabData} tabData={tabData} saveData={saveData} /></div>
            case 3:
                return <div><StatementTab FinancialStTypes={FinancialStTypes} FormattedSections={FormattedSections}
                    TabID={tab.FinancialStatementTabId} FinancialTotal={FinancialStatementsTypesTotals}
                    GeneralData={GeneralData} FinancialDetails={FinancialDetails}
                    onEdit={HandleEditFinancialSummaryDetail} setTabData={setTabData} tabData={tabData} saveData={saveData} /></div>
        }

    }
    return (
        <>
            <Tabs id="uncontrolled-tab-example" className="mb-3" defaultActiveKey={activeTab} onSelect={(tabId) => { setActiveTab(tabId) }}>
                {tabs?.map(tab => {
                    return <Tab eventKey={tab.FinancialStatementTabId} title={tab.FinancialStatementTabName} key={tab.FinancialStatementTabId} >
                        {
                            renderTab(tab)
                        }
                    </Tab>
                })}
            </Tabs>
        </>
    )
}


//Financial Statement tab
const StatementTab = ({ FinancialTotal,expandAllAccordian, FinancialDetails, FormattedSections, FinancialStTypes, TabID, GeneralData, onEdit, setTabData, tabData, assetId, year, saveData }) => {

    return <>
        <div className='d-flex'>
            {/* <button className='p-sm-btn ms-auto' onClick={ToggleCollapse}>{buttonText}</button> */}
        </div>
        {FormattedSections?.map(section => {
            if (section.TabID == TabID && section.FinancialStatementSectionId !== 0)
                return <div key={section.FinancialStatementSectionId} className='my-1' style={{ padding: "10px 0px 0px 10px" }}>
                    <h5 className='fw-Bold'>
                        {section.FinancialStatementSectionName || "Summary"}
                    </h5>
                    {FinancialStTypes?.map(subSection => {
                        if (subSection.FinancialStatementSectionId == section.FinancialStatementSectionId) {
                            if (subSection.FinancialStatementTypeId == 16) {
                                return <div key={subSection.FinancialStatementTypeId} className='p-1'>
                                    <ExpandCollapseAccordionGeneral tittle={subSection.FinancialStatementTypeName} GeneralData={GeneralData} setTabData={setTabData} tabData={tabData} saveData={saveData}>
                                    </ExpandCollapseAccordionGeneral>
                                </div>
                            }
                            if (subSection.FinancialStatementTypeId !== 16) {
                                return <div key={subSection.FinancialStatementTypeId} className='p-1'>
                                    <AccordionTab  expandAllAccordian={expandAllAccordian} tittle={subSection.FinancialStatementTypeName} TypeId={subSection.FinancialStatementTypeId} TabId={TabID} saveData={saveData} >
                                        <AccordionItemStatementTab TitleName={subSection.FinancialStatementTypeName} FinancialDetails={FinancialDetails} FinancialTotals={FinancialTotal} subSection={subSection} Totaltype={FinancialTotal} onEdit={onEdit} setTabData={setTabData} tabData={tabData} saveData={saveData} />
                                    </AccordionTab>
                                </div>
                            }

                        }
                    })
                    }
                </div>
        })}
    </>
}

//Accordion section
const AccordionTab = ({ tittle, children,expandAllAccordian, TypeId, TabId, TabData, saveData }) => {
    const [showstmt, setshowstmt] = useState(false);
    const [statementName, setStatementName] = useState();
    const [SecurityId, setSecurityId] = useState();
    const [selectedsecurityData, setselectedsecurityData] = useState();
    const [already, setalready] = useState();
    const [selectedItem, setSelectedItem] = useState(null);
    const [selectedSecurity, setSelectedSecurity] = useState([]);
    const [checkall, setcheckall] = useState(false);
    const dispatch = useDispatch();
    const Gstate = useSelector((state) => { return state }) || {};
    // const securityData = Gstate?.fsSecurityDropdown?.fsSecurityDropdown || [];
    const [securityData,setSecurityData]=useState([]);
    const details = saveData;

    const txtstatementChange = (event) => {
        setStatementName(event.target.value);
    }
    const closeStmtModal = () => {
        setshowstmt(false);
    }
    const OpenStmtModal = (e) => {
        setSelectedSecurity(va=>null);
        setSecurityData(val=>[]);
        setselectedsecurityData();
        setshowstmt(true);
        e.stopPropagation();
    }
    const FssecurityFilterChange=async(e)=>{
        const searchText = e?.filter?.value ?? "";
        if(searchText.length > 1)
        sbaAxios({url:getSecuritiesAPI+"?searchString="+searchText}).then(res=>{
            setSecurityData(val=>res);
        }).catch(error=>{
            setSecurityData(val=>[]);
            SBNotify({Msg:"Error Fetching Securities",type:"error"})
        })
    }

    const FssecurityChange = async (e) => {
        debugger;
        if(e.value)
        {
            const selSecurityItem =e.value;
            setSelectedSecurity(val=>selSecurityItem);
            // setSecurityId(selSecurityItem.FinancialId)
    
             const checkResponse = await sbaAxios({
                 url: `${CheckExistsFinancialStatementInvestment}${TabData.FinancialStatementSummaryId},${selSecurityItem.SecurityId},${TypeId}`,
                 method: 'get',
             });
    
             setalready(checkResponse === true);

        }
       
        // const searchText = e.value ?? "";
        // if ( e.syntheticEvent?.type === "change" && searchText.length > 1) {
        //     sbaAxios({url:getSecuritiesAPI+"?searchString="+searchText}).then(res=>{
        //         setSecurityData(val=>res);
        //     }).catch(error=>{
        //         setSecurityData(val=>[]);
        //         SBNotify({Msg:"Error Fetching Securities",type:"error"})
        //     })
        //     // Dispatch the async call to update dropdown values
        //     // dispatch(GetFinancialInvestmentsDropdownAction(0, 50, searchText));
        // }
        // if (e.syntheticEvent?.type === "click") {
          
        //     try {
        //         // const response = await sbaAxios({
        //         //     url: `${getFinancialInvestmentsDropdown}?offset=0&next=50&searchText=${searchText}`,
        //         //     method: 'get',
        //         // });

        //         // const securityDatas = response;

        //         const selSecurityItem = securityData.find(item => item.SecurityName === searchText);

        //         if (selSecurityItem) {
        //             setSelectedSecurity(selSecurityItem);
        //            // setSecurityId(selSecurityItem.FinancialId)

        //             const checkResponse = await sbaAxios({
        //                 url: `${CheckExistsFinancialStatementInvestment}${TabData.FinancialStatementSummaryId},${selSecurityItem.SecurityId},${TypeId}`,
        //                 method: 'get',
        //             });

        //             setalready(checkResponse === true);
        //         }
        //     }
        //     catch (error) {
        //         console.error("Error fetching security data:", error);
        //     }
        // } 
    };


    const SaveStatementName = (event) => {

        event.preventDefault();
        let saveSuccess = true;
        let errorMsg = [];
        // Prepare the data to be sent in the POST request
        const data = {
            "financialStatementName": statementName,
            "financialStatementTypeId": TypeId
        };
        if (!statementName) {
            saveSuccess = false;
            errorMsg.push("Statement Name is Required");
        }


        if (saveSuccess) {
            sbaAxios({
                url: `${InsertorUpdateStatement}${statementName},${TypeId}`,
                method: 'get',
            })
                .then((response) => {
                    toast.success("Statement Saved Successfully", {

                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    })
                    setshowstmt(false);
                    setTimeout(() => {
                        dispatch(getFinancialStatementAction(saveData.AssetId, saveData.FinYear));
                    }, 100);

                })

                .catch((error) => {
                    console.error(error);
                });
        }
        else {
            let ErrorString = "";
            errorMsg.map(item => { ErrorString = `${ErrorString}${item} \n` });
            console.log(errorMsg);
            toast.error(ErrorString, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
        }
    }

    const SecurityCalculation = (type) => {
        let Totalval = 0;
        saveData.FinancialInvestmentDetail.map(function (item, i) {
            if (item.FinancialStatementTypeName === type) {
                if ($('#txt_' + item.FinancialStatementTypeName.replace(/[\s&]/g, "") + '_' + item.FinancialStatementInvestmentId).val() != undefined) {
                    if ($('#txt_' + item.FinancialStatementTypeName.replace(/[\s&]/g, "") + '_' + item.FinancialStatementInvestmentId).val() != "") {
                        var a = $('#txt_' + item.FinancialStatementTypeName.replace(/[\s&]/g, "") + '_' + item.FinancialStatementInvestmentId).val().replace(/,/g, '');
                        Totalval = (parseFloat(parseFloat(Totalval) + parseFloat(a)));
                    }
                    else {
                        $('#txt_' + item.FinancialStatementTypeName.replace(/[\s&]/g, "") + '_' + item.FinancialStatementInvestmentId).val("0.00");
                    }
                }

            }
        });

        if (saveData.FinancialStatementsTypesTotals.length > 0) {
            if (type === "Investments in securities") {
                let totalinvSecurities = Math.round(Totalval * 100) / 100;
                $('#txt_TotalInvestmentSecurities').val(ThousandsSeparators(totalinvSecurities));
            }
            if (type == "Derivative contracts") {
                let totalDerivatives = Math.round(Totalval * 100) / 100;
                $('#txt_TotalDerivativeContracts').val(ThousandsSeparators(totalDerivatives));
            }
            if (type == "Securities Sold") {
                let totalSold = Math.round(Totalval * 100) / 100;
                $('#txt_TotalSecuritiesSold').val(ThousandsSeparators(totalSold));
            }


        }
        //Percentage calc
        //--Percentage value Start---//
        saveData.FinancialInvestmentDetail.map(function (item, i) {

            if (item.FinancialStatementTypeName === type) {
                if ($('#txt_' + item.FinancialStatementTypeName.replace(/[\s&]/g, "") + '_' + item.FinancialStatementInvestmentId).val() != undefined) {
                    const Assetval = $('#txt_' + item.FinancialStatementTypeName.replace(/[\s&]/g, '') + '_' + item.FinancialStatementInvestmentId).val().replace(/,/g, '')
                    $('#txt_' + item.FinancialStatementTypeName.replace(/[\s&]/g, '') + '_' + item.FinancialStatementInvestmentId).val(ThousandsSeparators(Assetval))
                    const NetAssetsval = $('#txt_NetAssets').val().replace(/,/g, '');
                    const netgain = (Assetval / NetAssetsval) * 100;
                    $('#txt_PCT_' + item.FinancialStatementTypeName.replace(/[\s&]/g, '') + '_' + item.FinancialStatementInvestmentId).val(FormatNumber(netgain));
                }

            }
        })

        if (type === "Investments in securities") {
            if ($('#txt_TotalInvestmentSecurities').val() != undefined && $('#txt_NetAssets').val() != undefined) {
                const totalSecurities = $('#txt_TotalInvestmentSecurities').val().replace(/,/g, '');
                const netAssets = $('#txt_NetAssets').val().replace(/,/g, '');
                $('#txtPC_TotalInvestmentSecurities').val(FormatNumber((totalSecurities / netAssets) * 100));
            }
        }
        if (type == "Derivative contracts") {
            if ($('#txt_TotalDerivativeContracts').val() != undefined && $('#txt_NetAssets').val() != undefined) {
                const totalderivatives = $('#txt_TotalDerivativeContracts').val().replace(/,/g, '');
                const netAssets = $('#txt_NetAssets').val().replace(/,/g, '');
                $('#txtPC_TotalDerivativeContracts').val(FormatNumber((totalderivatives / netAssets) * 100));
            }
        }
        if (type == "Securities Sold") {
            if ($('#txt_TotalSecuritiesSold').val() != undefined && $('#txt_NetAssets').val() != undefined) {
                const totalsold = $('#txt_TotalSecuritiesSold').val().replace(/,/g, '');
                const netAssets = $('#txt_NetAssets').val().replace(/,/g, '');
                $('#txtPC_TotalSecuritiesSold').val(FormatNumber((totalsold / netAssets) * 100));
            }
        }
    }

    useEffect(() => {
        saveData.FinancialStatementTypes.forEach((item) => {
            if (item.FinancialStatementTabId === 2) {
                SecurityCalculation(item.FinancialStatementTypeName);
            }
        });
    }, [SecurityCalculation]);

    const saveInvestments = async (title) => {
        let saveSuccess = true;
        let errorMsg = [];

        console.log(selectedsecurityData,'selectedsecurityData');

        const selectedSecurityItemn = securityData.find(item => item.SecurityName === selectedsecurityData);
        if(!selectedSecurity?.SecurityId)
        {
            SBNotify({Msg:"Please Select Any Security",type:"error"})
            return

        }

        const financialInvestments = [{
            "securityId": selectedSecurity?.SecurityId,
            "financialStatementTypeId": TypeId,
            "investmentValue": 0,
            "isVerified": false,
        }];
        const financialInvestmentData = {
            "financialStatementSummaryId": TabData.FinancialStatementSummaryId,
            "assetId": TabData.AssetId,
            "finYear": TabData.FinYear,
            "totalInvestmentSecurities": 0,
            "totalDerivativeContracts": 0,
            "totalSecuritiesSold": 0,
            "financialInvestments": financialInvestments,
            "createdby": 0,
        };

        if (already === true) {
            saveSuccess = false;
            errorMsg.push("Investment Securities Already Exists");
        }

        if (saveSuccess) {
            try {
                const response = await sbaAxios({
                    url: `${InsertFinancialInvestmentTotal}`,
                    method: 'post',
                    data: financialInvestmentData,
                });

                setshowstmt(false);
                toast.success("Investment Securities Saved Successfully", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                await new Promise((resolve) => {
                    dispatch(getFinancialStatementAction(TabData.AssetId, TabData.FinYear));
                    resolve();
                });
              
               // await new Promise(resolve => setTimeout(resolve, 0));


                saveData.FinancialStatementTypes.forEach((item) => {
                    if (item.FinancialStatementTabId === 2) {
                        SecurityCalculation(item.FinancialStatementTypeName);
                    }
                });

                //setTimeout(() => {
                //    saveData.FinancialStatementTypes.map(function (item, i) {
                //        if (item.FinancialStatementTabId === 2) {
                //            SecurityCalculation(item.FinancialStatementTypeName);
                //        }
                //    })
                //}, 1000);
            } catch (error) {
                console.error(error);
            }
        } else {
            let ErrorString = "";
            errorMsg.map((item) => {
                ErrorString = `${ErrorString}${item} \n`;
            });

            toast.error(ErrorString, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };

    const SecurityItemOnSelect = (e) => {
        //setSelectedSecurityItem(e.v)
    };
    const checkboxonclk = (e, tittle) => {

        let headerchkbox = $("#Headerchk_" + tittle.replace(/[\s*&\s*()_/]+/g, '') + "").prop("checked");
        if (headerchkbox === true) {

            setcheckall(true);
            $("#divchk_" + tittle.replace(/[\s*&\s*()_/]+/g, '') + " input[type=checkbox]").each(function () {
                $(this).prop("checked", true);
            });
            if (TabId === 1 || TabId === 3) {
                saveData.FinancialDetails = saveData.FinancialDetails.map(item => {
                    if (item.FinancialStatementTypeName === tittle) {
                        return {
                            ...item,
                            IsVerified: true
                        };
                    } else {
                        return item;
                    }
                });
            }
            else {
                saveData.FinancialInvestmentDetail = saveData.FinancialInvestmentDetail.map(item => {
                    if (item.FinancialStatementTypeName === tittle) {
                        return {
                            ...item,
                            IsVerified: true
                        };
                    } else {
                        return item;
                    }
                });
            }

        }


        if (headerchkbox === false) {
            setcheckall(false);
            $("#divchk_" + tittle.replace(/[\s*&\s*()_/]+/g, '') + " input[type=checkbox]").each(function () {
                $(this).prop("checked", false);
            });
            if (TabId === 1 || TabId === 3) {
                saveData.FinancialDetails = saveData.FinancialDetails.map(item => {
                    if (item.FinancialStatementTypeName === tittle) {
                        return {
                            ...item,
                            IsVerified: false
                        };
                    } else {
                        return item;
                    }
                });
            }

            else {
                saveData.FinancialInvestmentDetail = saveData.FinancialInvestmentDetail.map(item => {
                    if (item.FinancialStatementTypeName === tittle) {
                        return {
                            ...item,
                            IsVerified: false
                        };
                    } else {
                        return item;
                    }
                });

            }

        }
        e.stopPropagation();




    };
    const setActiveTab=(typeId)=>{
        try {
            sessionStorage.setItem("FSActiveAccordion",typeId);
        } catch (error) {
            sessionStorage.setItem("FSActiveAccordion",null);
        }
    }
    const getActiveTab=sessionStorage.getItem("FSActiveAccordion") || null;

    return <><Accordion defaultActiveKey={ expandAllAccordian || getActiveTab==TypeId ?  0 :null} onSelect={(eventKey)=>{if(eventKey!=null)setActiveTab(TypeId)}}>
        <Accordion.Item eventKey={0} >
            <Accordion.Header > <span className="title">{tittle}</span>

                <input type='checkbox' id={"Headerchk_" + tittle.replace(/[\s*&\s*()_/]+/g, '')} checked={checkall} onClick={(e) => checkboxonclk(e, tittle, saveData)}></input>
                {TabId != 3 && (
                    <div style={{ paddingLeft: "5px", paddingRight: "5px" }}> <i class="fa-solid fa-add SBA_icon mx-22" onClick={OpenStmtModal}></i></div>
                )
                }
            </Accordion.Header>
            <Accordion.Body>
                {children}
            </Accordion.Body>
        </Accordion.Item>

        <div>
            {TabId == 1 && (<Modal show={showstmt} >
                <Modal.Header closeButton onClick={closeStmtModal}>
                    <Modal.Title>Statement Name</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <label className="label">Statement Name</label>
                        <div>
                            <input
                                className="form-control w-75"
                                type="text"
                                onChange={txtstatementChange}
                            />
                        </div>

                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <button className="s-sm-btn mx-1" onClick={closeStmtModal} > Cancel</button>
                    <button className='p-sm-btn mx-1' onClick={SaveStatementName}>
                        Save
                    </button>
                </Modal.Footer>
            </Modal>
            )}

            {TabId == 2 && (<Modal show={showstmt} >
                <Modal.Header closeButton onClick={closeStmtModal}>
                    <Modal.Title>Security Name</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div>
                            <label className="label">Security Name</label>
                        </div>
                        <div>
                            <SBAComboBox
                                data={securityData}
                                textField={'SecurityName'}
                                valueField={'SecurityId'}
                                value={selectedSecurity}
                                popupSettings={{ className: 'modalDD' }}
                                onChange={FssecurityChange}
                                onFilterChange={FssecurityFilterChange}
                            ></SBAComboBox>
                            {/* <AutoComplete
                                data={securityData}
                                value={selectedsecurityData}
                                textField={'SecurityName'}
                                valueField={'SecurityId'}
                                popupSettings={{ className: 'modalDD' }}
                                onChange={FssecurityChange}
                                clearButton={false}
                            /> */}
                        </div>

                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <button className="s-sm-btn mx-1" onClick={closeStmtModal} > Cancel</button>
                    <button className='p-sm-btn mx-1' onClick={() => { saveInvestments(tittle) }}>
                        Save
                    </button>
                </Modal.Footer>

            </Modal>
            )}
        </div>

    </Accordion>
    </>
}

//Financial statements tab items


export const EachQElementStatementTab = ({ TitleName, financialStatementItem, FinancialTotals, FinancialDetails, onEdit, tabData, setTabData, saveData }) => {

    const [showstatementdeletemodal, setshowstatementdeletemodal] = useState(false);
    const [statementId, setstatementId] = useState();
    const [statementTypeId, setstatementTypeId] = useState();
    const [statementTypeName, setstatementTypeName] = useState();
    const [StatementSummaryId, setStatementSummaryId] = useState(tabData.FinancialStatementSummaryId);
    const [stmtisverfied, setstmtisverfied] = useState(financialStatementItem.IsVerified);
    const dispatch = useDispatch();
    const AssetCalculation = (type) => {
        let Totalval = 0;
        let Totaldecrease = 0;
        //---Total Calculation Start--//
        FinancialDetails.map(function (item, i) {
            if (item.FinancialStatementTypeName === type) {
                if ($('#txt_' + item.FinancialStatementTypeName.replace(/[\s&]/g, "") + '_' + item.FinancialStatementId).val() != undefined) {
                    if ($('#txt_' + item.FinancialStatementTypeName.replace(/[\s&]/g, "") + '_' + item.FinancialStatementId).val() != "") {
                        var a = $('#txt_' + item.FinancialStatementTypeName.replace(/[\s&]/g, "") + '_' + item.FinancialStatementId).val().replace(/,/g, '');
                        Totalval = (parseFloat(parseFloat(Totalval) + parseFloat(a)));
                    }
                    else {
                        $('#txt_' + item.FinancialStatementTypeName.replace(/[\s&]/g, "") + '_' + item.FinancialStatementId).val("0.00");
                    }
                }
            }

        });
        if (type === "Statement of Changes - Net Increase") {
            let netAsset = Math.round(Totalval * 100) / 100;
            $('#txt_StatementofChanges-NetDecrease_0').val(ThousandsSeparators(netAsset));
            FinancialDetails.map(function (item, i) {
                if (item.FinancialStatementTypeName === "Statement of Changes - Net Decrease") {
                    if ($('#txt_' + item.FinancialStatementTypeName.replace(/[\s&]/g, "") + '_' + item.FinancialStatementId).val() != undefined) {
                        if ($('#txt_' + item.FinancialStatementTypeName.replace(/[\s&]/g, "") + '_' + item.FinancialStatementId).val() != "") {
                            var a = $('#txt_' + item.FinancialStatementTypeName.replace(/[\s&]/g, "") + '_' + item.FinancialStatementId).val().replace(/,/g, '');
                            Totaldecrease = (parseFloat(parseFloat(Totaldecrease) + parseFloat(a)));
                        }
                        else {
                            $('#txt_' + item.FinancialStatementTypeName.replace(/[\s&]/g, "") + '_' + item.FinancialStatementId).val("0.00");
                        }
                    }
                }
            });
        }
        if (FinancialTotals.length > 0) {
            if (type === "Assets") {
                let Assetsval = Math.round(Totalval * 100) / 100;
                $('#txt_TotalAssets').val(ThousandsSeparators(Assetsval));
                const asvalue = $('#txt_TotalAssets').val().replace(/,/g, '');
                $('#txt_NetAssets').val(FormatNumber((parseFloat(parseFloat(asvalue) - parseFloat($('#txt_TotalLiabilities').val().replace(/,/g, ''))) * 100) / 100));
            }
            else if (type === "Liabilities") {
                let liabilityval = Math.round(Totalval * 100) / 100;
                $('#txt_TotalLiabilities').val(ThousandsSeparators(liabilityval));
                const liabilityTotal = $('#txt_TotalLiabilities').val().replace(/,/g, '');
                $('#txt_NetAssets').val(FormatNumber((parseFloat(parseFloat($('#txt_TotalAssets').val().replace(/,/g, '')) - parseFloat(liabilityTotal)) * 100) / 100));
            }
            else if (type === "Partners Capital") {
               
                const liabilityTotal = $('#txt_TotalLiabilities').val().replace(/,/g, '');
                $('#txt_NetAssets').val(FormatNumber((parseFloat(parseFloat($('#txt_TotalAssets').val().replace(/,/g, '')) - parseFloat(liabilityTotal)) * 100) / 100));
            }
            else if (type === "Investment Income") {
                let income = Math.round(Totalval * 100) / 100;
                $('#txt_TotalInvestmentIncome').val(ThousandsSeparators(income));              
                $('#txt_Netinvestmentincomeloss').val(FormatNumber((parseFloat(parseFloat(income) - parseFloat($('#txt_TotalExpenses').val().replace(/,/g, ''))) * 100) / 100));
                let netincreasedecrease=Math.round(parseFloat(parseFloat($('#txt_Netinvestmentincomeloss').val().replace(/,/g, '')) + parseFloat($('#txt_Netgainlossfrominvestmenttransactions').val().replace(/,/g, ''))) * 100) / 100;
                $('#txt_Netincreasedecreaseinnetassetsresultingforoperations').val(ThousandsSeparators(netincreasedecrease));
            }
            else if (type === "Expenses") {
                let expense = Math.round(Totalval * 100) / 100;
                $('#txt_TotalExpenses').val(ThousandsSeparators(expense));
                let netincome = Math.round(parseFloat(parseFloat($('#txt_TotalInvestmentIncome').val().replace(/,/g, '')) - parseFloat(Totalval)) * 100) / 100;
                $('#txt_Netinvestmentincomeloss').val(ThousandsSeparators(netincome));
                let netincreasedecrease=Math.round(parseFloat(parseFloat($('#txt_Netinvestmentincomeloss').val().replace(/,/g, '')) + parseFloat($('#txt_Netgainlossfrominvestmenttransactions').val().replace(/,/g, ''))) * 100) / 100;
                $('#txt_Netincreasedecreaseinnetassetsresultingforoperations').val(ThousandsSeparators(netincreasedecrease));
            }
            else if (type === "Net Gain & Lost from Investment Transations") {
                let netgain = Math.round(Totalval * 100) / 100;
                $('#txt_Netgainlossfrominvestmenttransactions').val(ThousandsSeparators(netgain));
                if ($('#txt_Netinvestmentincomeloss').val() != undefined) {
                    let increasedecreasegain = Math.round(parseFloat(parseFloat($('#txt_Netinvestmentincomeloss').val().replace(/,/g, '')) + parseFloat($('#txt_Netgainlossfrominvestmenttransactions').val().replace(/,/g, ''))) * 100) / 100;
                    $('#txt_Netincreasedecreaseinnetassetsresultingforoperations').val(ThousandsSeparators(increasedecreasegain));
                }
            }
            else if (type === "Statement of Changes - Net Increase") {
                $('#txt_NetAssetsEndofYear').val(ThousandsSeparators(Totaldecrease));
            }
            else if (type === "Statement of Changes - Net Decrease") {
                let netAsset = Math.round(Totalval * 100) / 100;
                $('#txt_NetAssetsEndofYear').val(ThousandsSeparators(netAsset));
            }
            else if (type === "Level X Asset") {
                let netXAsset = Math.round(Totalval * 100) / 100;
                $('#txt_TotalAssets.12-Total').val(ThousandsSeparators(netXAsset));
            }
            else if (type == "Level X Liabilities") {
                let netXLiability = Math.round(Totalval * 100) / 100;
                $('#txt_TotalLiabilities.13-Total').val(ThousandsSeparators(netXLiability));
            }
            else if (type === "Returns before Incentive Fee") {
                let totalVal = Math.round(Totalval * 100) / 100;
                $('#txt_TotalReturnAfterIncentiveFee').val(ThousandsSeparators(totalVal));
            }
            //---Total Calculation End--//


            //--Percentage value Start---//
            FinancialDetails.map(function (item, i) {
                if (item.FinancialStatementTypeName === type) {
                    if ($('#txt_' + item.FinancialStatementTypeName.replace(/[\s&]/g, "") + '_' + item.FinancialStatementId).val() != undefined) {
                        const Assetval = $('#txt_' + item.FinancialStatementTypeName.replace(/[\s&]/g, '') + '_' + item.FinancialStatementId).val().replace(/,/g, '')
                       // $('#txt_' + item.FinancialStatementTypeName.replace(/[\s&]/g, '') + '_' + item.FinancialStatementId).val(ThousandsSeparators(Assetval))
                        const NetAssetsval = $('#txt_NetAssets').val().replace(/,/g, '');
                        const netgain = (Assetval / NetAssetsval) * 100;
                        $('#txt_PCT_' + item.FinancialStatementTypeName.replace(/[\s&]/g, '') + '_' + item.FinancialStatementId).val(FormatNumber(netgain));


                    }

                }

            })
            if (type === "Assets") {
                if ($('#txt_TotalAssets').val() != undefined && $('#txt_NetAssets').val() != undefined) {
                    const totalasset = $('#txt_TotalAssets').val().replace(/,/g, '');
                    const netAssets = $('#txt_NetAssets').val().replace(/,/g, '');
                    $('#txtPC_TotalAssets').val(FormatNumber((totalasset / netAssets) * 100));
                }
            }
            else if (type === "Liabilities") {
                if ($('#txt_TotalLiabilities').val() != undefined && $('#txt_NetAssets').val() != undefined) {
                    const totalliabilities = $('#txt_TotalLiabilities').val().replace(/,/g, '');
                    const netAssets = $('#txt_NetAssets').val().replace(/,/g, '');
                    $('#txtPC_TotalLiabilities').val(FormatNumber((totalliabilities / netAssets) * 100));
                    $('#txtPC_NetAssets').val(FormatNumber((netAssets / netAssets) * 100));
                }
            }
            else if (type == "Investment Income") {
                $('#txtPC_TotalInvestmentIncome').val(FormatNumber(($('#txt_TotalInvestmentIncome').val().replace(/,/g, '') / $('#txt_NetAssets').val().replace(/,/g, '')) * 100));
            }
            else if (type == "Expenses") {
                $('#txtPC_TotalExpenses').val(FormatNumber(($('#txt_TotalExpenses').val().replace(/,/g, '') / $('#txt_NetAssets').val().replace(/,/g, '')) * 100));
                $('#txtPC_Netinvestmentincomeloss').val((($('#txt_Netinvestmentincomeloss').val().replace(/,/g, '') / $('#txt_NetAssets').val().replace(/,/g, '')) * 100).toFixed(2));
            }
            else if (type == "Net Gain & Lost from Investment Transations") {
                //let resultingoperation=Math.round(parseFloat(parseFloat($('#txt_TotalInvestmentIncome').val().replace(/,/g, '')) + parseFloat($('#txt_Netincreasedecreaseinnetassetsresultingforoperations').val().replace(/,/g, ''))) * 100) / 100
                //$('#txt_Netincreasedecreaseinnetassetsresultingforoperations').val(ThousandsSeparators(resultingoperation));
                if ($('#txt_Netgainlossfrominvestmenttransactions').val() != undefined && $('#txt_Netincreasedecreaseinnetassetsresultingforoperations').val() != undefined && $('#txt_NetAssets').val() != undefined) {
                    $('#txtPC_Netgainlossfrominvestmenttransactions').val(FormatNumber(($('#txt_Netgainlossfrominvestmenttransactions').val().replace(/,/g, '') / $('#txt_NetAssets').val().replace(/,/g, '')) * 100));

                    var Netincreasedecrease = $('#txt_Netincreasedecreaseinnetassetsresultingforoperations').val().replace(/,/g, '');
                    if ($('#txt_NetAssets').val() != undefined) {
                        var netassets = $('#txt_NetAssets').val().replace(/,/g, '');
                        $('#txtPC_Netincreasedecreaseinnetassetsresultingforoperations').val(FormatNumber((Netincreasedecrease / netassets) * 100));
                    }
                }
            }

            else if (type === "Statement of Changes - Net Increase" || type === "Statement of Changes - Net Decrease") {
                var NetincreasedecreaseEndofyear = $('#txt_NetAssetsEndofYear').val().replace(/,/g, '');
                var netassets = $('#txt_NetAssets').val().replace(/,/g, '');
                var pcnetasset = FormatNumber((NetincreasedecreaseEndofyear / netassets) * 100);
                $('#txtPC_NetAssetsEndofYear').val(pcnetasset)
            }
        }

        //--Percentage value End---//
    }

    const DeleteStatementModal = (item) => {

        setshowstatementdeletemodal(true);
        setstatementId(item.FinancialStatementId);
        setstatementTypeId(item.FinancialStatementTypeId);
        setstatementTypeName(item.FinancialStatementTypeName);

    }
    const closedeletestatementModal = () => {
        setshowstatementdeletemodal(false);
    }


    const DeleteStatemnts = () => {
        setshowstatementdeletemodal(false);
        sbaAxios({
            url: `${Deletenonverifiedstatement}${statementId},${statementTypeId}`,
            method: 'get',
        }).then(response => {
            if (response === -999) {
                SBNotify({ type: "error", Msg: 'Statement Cannot be deleted' });
            }
            else {
                SBNotify({ type: "success", Msg: 'Statement Deleted Successfully' });

                setTimeout(() => {
                    dispatch(getFinancialStatementAction(tabData.AssetId, tabData.FinYear));
                    AssetCalculation(statementTypeName);
                }, 1000);
            }
        })

            .catch(error => {
                console.error('Error deleting data:', error);
            });

    }
    return <>
        {financialStatementItem.isHidden === false &&
            <>
                <div className="py-2 row">
                    <div className='col-md-4'>
                        <label className='darkLabel'>{financialStatementItem.FinancialStatementName}</label>
                    </div>
                    <div className="d-flex col flex-grow-1" >

                        {/* Addd IsVerified and ISsuperUser  To Disable the box  */}
                        <InputGroup className="mx-2">
                            <InputGroup.Text>$</InputGroup.Text>

              <Form.Control
                key={financialStatementItem.FinancialStatementId}
                defaultValue={FormatNumber(financialStatementItem.FinancialStatementName === 'Net increase/(decrease) of net assets' ? tabData.NetIncreaseDecreaseAsset : financialStatementItem.Value)}
                disabled={
                    (financialStatementItem.FinancialStatementName === 'Net increase/(decrease) of net assets' ? true : false)
                    || financialStatementItem.IsVerified
                }
                className={`${financialStatementItem.FinancialStatementId}-TextBox ${financialStatementItem.FinancialStatementTypeId}-Type-TextBox CurrencyText`}
                id={"txt_" + financialStatementItem.FinancialStatementTypeName.replace(/[\s&]+/g, '') + '_' + financialStatementItem.FinancialStatementId}
                onBlur={(e) => {
                  let TotalElement = document.getElementsByClassName(`${financialStatementItem.FinancialStatementTypeId}-Total`)[0];
                  //onEdit(financialStatementItem.FinancialStatementId, financialStatementItem.FinancialStatementTypeId, RemoveThousandSep(e.target.value))
                  const updatedValue = e.target.value;
                  const FinancialStId = financialStatementItem.FinancialStatementId;
                  let financialStTotaltypes = saveData.FinancialStatementsTypesTotals;
                  const UpdateFinancialDetails = saveData.FinancialDetails.map(item => {
                    if (item.FinancialStatementId == FinancialStId) {
                        $('#txt_' + item.FinancialStatementTypeName.replace(/[\s&]/g, '') + '_' + item.FinancialStatementId).val(ThousandsSeparators(updatedValue))
                      return {
                        ...item,
                        Value: RemoveThousandSep(updatedValue)
                      }
                    }
                    else {
                      return item
                    }
                  });
                    if (TotalElement) {             
                    const TotalTypeId = financialStatementItem.FinancialStatementTypeId;
                    const updatedValue = FormatNumber(Array.from(
                      document.getElementsByClassName(`${financialStatementItem.FinancialStatementTypeId}-Type-TextBox`)
                    ).map(e => RemoveThousandSep(e.value) || 0)
                      .reduce((a, b) => a + b, 0));
                    document.getElementsByClassName(`${financialStatementItem.FinancialStatementTypeId}-Total`)[0].value = financialStatementItem.FinancialStatementTypeName === "Partners Capital" ? FormatNumber(saveData.FinancialStatementsTypesTotals.filter(item => item.FinancialStatementTypeId === 8)[0]?.FinancialStatementTypeTotal) : updatedValue;
                    financialStTotaltypes = saveData.FinancialStatementsTypesTotals.map(item => {
                        if (item.FinancialStatementTypeId == TotalTypeId) { 
                                             
                        return {
                          ...item,
                            FinancialStatementTypeTotal: financialStatementItem.FinancialStatementTypeName === "Partners Capital" ? item.FinancialStatementTypeTotal : RemoveThousandSep(updatedValue),
                        }
                      }
                      else {
                        return { ...item }
                      }
                    })
                  }
                  AssetCalculation(financialStatementItem.FinancialStatementTypeName);
                    const newSaveDate = { ...saveData, NetIncreaseDecreaseAsset: $('#txt_StatementofChanges-NetDecrease_0').val(), NetAssetEOY: $("#txt_NetAssetsEndofYear").val(), NetGainInvestIncome: $("#txt_Netgainlossfrominvestmenttransactions").val(), NetIncreaseAsset: $("#txt_Netincreasedecreaseinnetassetsresultingforoperations").val(), NetInvestIncome: $("#txt_Netinvestmentincomeloss").val(), FinancialStatementsTypesTotals: financialStTotaltypes, FinancialDetails: UpdateFinancialDetails, NetAssets: $("#txt_NetAssets").val() };
                  setTabData(newSaveDate)
                }
                } />


                        </InputGroup>

                        {financialStatementItem.FinancialStatementTabId !== 3 &&
                            <><InputGroup className="mx-2">
                                <InputGroup.Text>%</InputGroup.Text>
                                <Form.Control type="text" className={`${financialStatementItem.FinancialStatementId}-TextBox-disabled`}
                                    defaultValue={FormatNumber(financialStatementItem.Value / GetTotalNetAsset(FinancialTotals) * 100.0)}
                                    disabled key={financialStatementItem.FinancialStatementId}
                                    style={{ width: "100px" }} id={"txt_PCT_" + financialStatementItem.FinancialStatementTypeName.replace(/[\s&]+/g, '') + '_' + financialStatementItem.FinancialStatementId}
                                />

                            </InputGroup>
                                <div id={"divchk_" + TitleName.replace(/[\s*&\s*()_/]+/g, '')}>
                                    <input type='checkbox' id={'txtVerified_' + financialStatementItem.FinancialStatementId} defaultChecked={stmtisverfied} onClick={() => {
                                        setstmtisverfied(value => !value)
                                        let verified = $("#txtVerified_" + financialStatementItem.FinancialStatementId).prop("checked");
                                        const UpdateFinancialDetails = saveData.FinancialDetails.map(item => {
                                            if (item.FinancialStatementId == financialStatementItem.FinancialStatementId) {
                                                return {
                                                    ...item,
                                                    IsVerified: verified
                                                }
                                            }
                                            else {
                                                return item
                                            }
                                        });
                                        setTabData(() => {
                                            return { ...saveData, FinancialDetails: UpdateFinancialDetails }
                                        })
                                    }} disabled={financialStatementItem.IsVerified}></input>
                                </div>
                                {!financialStatementItem.IsVerified && (<i className="fa fa-times" style={{ color: "#47A547", margin: "8px 8px", cursor: "pointer", marginTop: "0%" }} onClick={(e) => { DeleteStatementModal(financialStatementItem) }}></i>)}

                            </>

                        }

                        {financialStatementItem.FinancialStatementTabId === 3 &&
                            <>
                                <div id={"divchk_" + TitleName.replace(/[\s*&\s*()_/]+/g, '')}>
                                    <input type='checkbox' id={'txtVerified_' + financialStatementItem.FinancialStatementId} defaultChecked={stmtisverfied} onChange={() => {
                                        setstmtisverfied(value => !value)
                                        let verified = $("#txtVerified_" + financialStatementItem.FinancialStatementId).prop("checked");
                                        const UpdateFinancialDetails = saveData.FinancialDetails.map(item => {
                                            if (item.FinancialStatementId == financialStatementItem.FinancialStatementId) {
                                                return {
                                                    ...item,
                                                    IsVerified: verified
                                                }
                                            }
                                            else {
                                                return item
                                            }
                                        });
                                        setTabData(() => {
                                            return { ...saveData, FinancialDetails: UpdateFinancialDetails }
                                        })
                                    }}
                                    disabled={financialStatementItem.IsVerified}></input>
                                </div>
                                <InputGroup className="mx-1"></InputGroup>
                            </>
                        }

                        {parseInt(financialStatementItem.AddQuestId.split(',')[1]) !== 0 &&
                            <><label className='darkLabel' style={{ padding: "5px 10px 0px 5px", marginLeft: "50px" }}>Notional</label><Form.Control type="text"
                                className={`${financialStatementItem.FinancialStatementId}-TextBox-enabled`}
                                defaultValue={FormatNumber(GetNotionalAmount(FinancialDetails, parseInt(financialStatementItem.AddQuestId.split(',')[1])))} />

                                <div id={"divchk_" + TitleName.replace(/[\s*&\s*()_/]+/g, '')}>
                                    <input type='checkbox' id='txtNotionalVerified' style={{ marginLeft: "10px" }} defaultChecked={financialStatementItem.IsVerified} disabled={financialStatementItem.IsVerified}></input>
                                </div>
                            </>

                        }

                        {parseInt(financialStatementItem.AddQuestId.split(',')[1]) === 0 && <></>
                            // <>{financialStatementItem.FinancialStatementTabId === 3 ? <div style={{ minWidth: "495px" }}></div> : <div style={{ minWidth: "395px" }}></div>}</>
                        }



                    </div>
                </div>
            </>
        }


        <Modal show={showstatementdeletemodal}  >
            <Modal.Header closeButton onClick={closedeletestatementModal}>
                <Modal.Title>Do you want to delete the Statement?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>The Statement will be deleted permanently. Are you sure?</p>
            </Modal.Body>
            <Modal.Footer>
                <button className="s-sm-btn mx-1" onClick={closedeletestatementModal} > Cancel</button>
                <button className='p-sm-btn mx-1' onClick={DeleteStatemnts}  >
                    Yes
                </button>
            </Modal.Footer>
        </Modal>
    </>




}

//Investments tab
export const EachQElementInvestTab = ({ TitleName, investmentDetailItem, InvestmentDetails, FinancialTotals, onEdit, tabData, setTabData, saveData }) => {
    const dispatch = useDispatch();
    const [showDeleteModal, setshowDeleteModal] = useState(false);
    const [InvestmentId, setInvestmentId] = useState();
    const [summaryId, setsummaryId] = useState();
    const [securitiesId, setsecuritiesId] = useState();
    const [typeId, settypeId] = useState();
    const [investIsVerfied, setinvestIsVerified] = useState(investmentDetailItem.IsVerified);
    const [typeName, settypeName] = useState();
    const InvestmentSecurityCalculation = (type) => {
        let Totalval = 0;
        InvestmentDetails.map(function (item, i) {
            if (item.FinancialStatementTypeName === type) {
                if ($('#txt_' + item.FinancialStatementTypeName.replace(/[\s&]/g, "") + '_' + item.FinancialStatementInvestmentId).val() != undefined) {
                    if ($('#txt_' + item.FinancialStatementTypeName.replace(/[\s&]/g, "") + '_' + item.FinancialStatementInvestmentId).val() != "") {
                        var a = $('#txt_' + item.FinancialStatementTypeName.replace(/[\s&]/g, "") + '_' + item.FinancialStatementInvestmentId).val().replace(/,/g, '');
                        Totalval = (parseFloat(parseFloat(Totalval) + parseFloat(a)));
                    }
                    else {
                        $('#txt_' + item.FinancialStatementTypeName.replace(/[\s&]/g, "") + '_' + item.FinancialStatementInvestmentId).val("0.00");
                    }
                }

            }
        });

        if (FinancialTotals.length > 0) {
            if (type === "Investments in securities") {
                let totalinvSecurities = Math.round(Totalval * 100) / 100;
                $('#txt_TotalInvestmentSecurities').val(ThousandsSeparators(totalinvSecurities));
            }
            if (type == "Derivative contracts") {
                let totalDerivatives = Math.round(Totalval * 100) / 100;
                $('#txt_TotalDerivativeContracts').val(ThousandsSeparators(totalDerivatives));
            }
            if (type == "Securities Sold") {
                let totalSold = Math.round(Totalval * 100) / 100;
                $('#txt_TotalSecuritiesSold').val(ThousandsSeparators(totalSold));
            }


        }
        //Percentage calc
        //--Percentage value Start---//
        InvestmentDetails.map(function (item, i) {
            if (item.FinancialStatementTypeName === type) {
                if ($('#txt_' + item.FinancialStatementTypeName.replace(/[\s&]/g, "") + '_' + item.FinancialStatementInvestmentId).val() != undefined) {
                    const Assetval = $('#txt_' + item.FinancialStatementTypeName.replace(/[\s&]/g, '') + '_' + item.FinancialStatementInvestmentId).val().replace(/,/g, '')
                    $('#txt_' + item.FinancialStatementTypeName.replace(/[\s&]/g, '') + '_' + item.FinancialStatementInvestmentId).val(ThousandsSeparators(Assetval))
                    const NetAssetsval = $('#txt_NetAssets').val().replace(/,/g, '');
                    const netgain = (Assetval / NetAssetsval) * 100;
                    $('#txt_PCT_' + item.FinancialStatementTypeName.replace(/[\s&]/g, '') + '_' + item.FinancialStatementInvestmentId).val(FormatNumber(netgain));
                }

            }
        })

        if (type === "Investments in securities") {
            if ($('#txt_TotalInvestmentSecurities').val() != undefined && $('#txt_NetAssets').val() != undefined) {
                const totalSecurities = $('#txt_TotalInvestmentSecurities').val().replace(/,/g, '');
                const netAssets = $('#txt_NetAssets').val().replace(/,/g, '');
                $('#txtPC_TotalInvestmentSecurities').val(FormatNumber((totalSecurities / netAssets) * 100));
            }
        }
        if (type == "Derivative contracts") {
            if ($('#txt_TotalDerivativeContracts').val() != undefined && $('#txt_NetAssets').val() != undefined) {
                const totalderivatives = $('#txt_TotalDerivativeContracts').val().replace(/,/g, '');
                const netAssets = $('#txt_NetAssets').val().replace(/,/g, '');
                $('#txtPC_TotalDerivativeContracts').val(FormatNumber((totalderivatives / netAssets) * 100));
            }
        }
        if (type == "Securities Sold") {
            if ($('#txt_TotalSecuritiesSold').val() != undefined && $('#txt_NetAssets').val() != undefined) {
                const totalsold = $('#txt_TotalSecuritiesSold').val().replace(/,/g, '');
                const netAssets = $('#txt_NetAssets').val().replace(/,/g, '');
                $('#txtPC_TotalSecuritiesSold').val(FormatNumber((totalsold / netAssets) * 100));
            }
        }
    }
    const handleDeleteClick = (item) => {
        setshowDeleteModal(true);
        setInvestmentId(item.FinancialStatementInvestmentId);
        setsummaryId(item.FinancialStatementSummaryId);
        setsecuritiesId(item.SecurityId);
        settypeId(item.FinancialStatementTypeId);
        settypeName(item.FinancialStatementTypeName);
    }
    const closedeleteModal = () => {
        setshowDeleteModal(false);
    }

    const [triggerCalculation, setTriggerCalculation] = useState(false);

    useEffect(() => {
        if (triggerCalculation) {
            const fetchData = async () => {
                try {
                    await InvestmentSecurityCalculation(typeName);
                } catch (error) {
                    console.error('Error calculating investment security:', error);
                }
            };

            fetchData();
            setTriggerCalculation(false); // Reset the trigger after the calculation
        }
    }, [triggerCalculation, typeName]);

    const DeleteSecurities = async () => {
        setshowDeleteModal(false);

        try {
            const response = await sbaAxios({
                url: `${DeleteNonVerifiedSecurities}${InvestmentId},${summaryId},${securitiesId},${typeId}`,
                method: 'get',
            });

            SBNotify({ type: "success", Msg: 'Securities Deleted Successfully' });
            await new Promise((resolve) => {
                dispatch(getFinancialStatementAction(tabData.AssetId, tabData.FinYear));
                resolve();
            });

            setTriggerCalculation(true);

            //setTimeout(() => {
            //    InvestmentSecurityCalculation(typeName);
            //}, 1000);

        } catch (error) {
            console.error('Error deleting data:', error);
        }
    };





    return <>
        <div className="py-2 row" >
            <div className='col-md-4'>
                <label className='darkLabel'>{investmentDetailItem.SecurityName}</label>
            </div>

            <div className="d-flex col flex-grow-1">
                {/* Addd IsVerified and ISsuperUser  To Disable the box  */}
                <InputGroup className="mx-2">
                    <InputGroup.Text>$</InputGroup.Text>
                    <Form.Control key={investmentDetailItem.InvestmentValue} defaultValue={FormatNumber(investmentDetailItem.InvestmentValue)}
                        className={`${investmentDetailItem.FinancialStatementId}-TextBox ${investmentDetailItem.FinancialStatementTypeId}-Type-TextBox CurrencyText`}
                        // disabled={investmentDetailItem.IsVerified}
                        id={"txt_" + investmentDetailItem.FinancialStatementTypeName.replace(/[\s&]+/g, '') + '_' + investmentDetailItem.FinancialStatementInvestmentId}
                        onChange={InvestmentSecurityCalculation(investmentDetailItem.FinancialStatementTypeName)}
                        onBlur={(e) => {
                            let TotalElement = document.getElementsByClassName(`${investmentDetailItem.FinancialStatementInvestmentId}-Total`)[0];
                            //onEdit(investmentDetailItem.FinancialStatementInvestmentId, investmentDetailItem.FinancialStatementTypeId, RemoveThousandSep(e.target.value));
                            const updatedValue = e.target.value.replace(/,/g, '');
                            const FinancialStatementInvestmentId = investmentDetailItem.FinancialStatementInvestmentId;
                            let newTypeTotals = saveData.FinancialStatementsTypesTotals;
                            const UpdateFinancialInvestDetails = saveData.FinancialInvestmentDetail.map(item => {
                                if (item.FinancialStatementInvestmentId == FinancialStatementInvestmentId) {
                                    return {
                                        ...item,
                                        InvestmentValue: updatedValue
                                    }
                                }
                                else {
                                    return item
                                }
                            });
                            if (TotalElement) {
                                const TotalTypeId = investmentDetailItem.FinancialStatementTypeId;
                                const updatedValue = FormatNumber(Array.from(
                                    document.getElementsByClassName(`${investmentDetailItem.FinancialStatementTypeId}-Type-TextBox`)
                                ).map(e => RemoveThousandSep(e.value) || 0)
                                    .reduce((a, b) => a + b, 0));
                                document.getElementsByClassName(`${investmentDetailItem.FinancialStatementTypeId}-Total`)[0].value = updatedValue;
                                newTypeTotals = saveData.FinancialStatementsTypesTotals.map(item => {
                                    if (item.FinancialStatementTypeId == TotalTypeId) {
                                        return {
                                            ...item,
                                            FinancialStatementTypeTotal: RemoveThousandSep(updatedValue),
                                        }
                                    }
                                    else {
                                        return { ...item }
                                    }
                                })
                            };
                            setTabData(() => {
                                return { ...saveData, FinancialInvestmentDetail: UpdateFinancialInvestDetails, FinancialStatementsTypesTotals: newTypeTotals }
                            })
                        }} />
                </InputGroup>
                <InputGroup className="mx-2">
                    <InputGroup.Text>%</InputGroup.Text>
                    <Form.Control type="text" className={`${investmentDetailItem.FinancialStatementInvestmentId}-TextBox-disabled ${investmentDetailItem.FinancialStatementInvestmentId}-Total`}
                        defaultValue={FormatNumber(investmentDetailItem.InvestmentValue / GetTotalNetAsset(FinancialTotals) * 100.0)}
                        disabled key={investmentDetailItem.InvestmentValue} id={"txt_PCT_" + investmentDetailItem.FinancialStatementTypeName.replace(/[\s&]+/g, '') + '_' + investmentDetailItem.FinancialStatementInvestmentId} />

                </InputGroup>
                <div id={"divchk_" + TitleName.replace(/[\s*&\s*()_/]+/g, '')}>
                    <input type='checkbox' id={'txtVerified_' + investmentDetailItem.FinancialStatementInvestmentId} defaultChecked={investIsVerfied} onClick={() => {
                        setinvestIsVerified(value => !value)
                        const UpdateInvestmentDetail = saveData.FinancialInvestmentDetail.map(item => {
                            if (item.FinancialStatementInvestmentId == investmentDetailItem.FinancialStatementInvestmentId) {
                                let verified = $("#txtVerified_" + investmentDetailItem.FinancialStatementInvestmentId).prop("checked");
                                return {
                                    ...item,
                                    IsVerified: verified
                                }
                            }
                            else {
                                return item

                            }
                        });
                        setTabData(() => {
                            return { ...tabData, FinancialInvestmentDetail: UpdateInvestmentDetail }
                        })
                    }} disabled={investmentDetailItem.IsVerified} ></input>
                </div>
                {!investmentDetailItem.IsVerified && (<i className="fa fa-times" style={{ color: "#47A547", margin: "8px 8px", cursor: "pointer", marginTop: "0%" }} onClick={(e) => { handleDeleteClick(investmentDetailItem) }}></i>)}

                <><div ></div></>

            </div>
        </div>


        <Modal show={showDeleteModal}  >
            <Modal.Header closeButton onClick={closedeleteModal}>
                <Modal.Title>Do you want to delete the Securities?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>The Securities will be deleted permanently. Are you sure?</p>
            </Modal.Body>
            <Modal.Footer>
                <button className="s-sm-btn mx-1" onClick={closedeleteModal} > Cancel</button>
                <button className='p-sm-btn mx-1' onClick={DeleteSecurities}  >
                    Yes
                </button>
            </Modal.Footer>
        </Modal>
    </>
}
export const TotalItem = ({ Item, FinancialTotals, subSection }) => {

    const [inputValue, setInputValue] = useState(FormatNumber(Item.FinancialStatementTypeTotal));
    const [pcvalue, setPCValue] = useState(FormatNumber(FormatNumber(Item.FinancialStatementTypeTotal / GetTotalNetAsset(FinancialTotals) * 100.0)))
    let name = "";

    return <>
        <div className=" py-2 row" >
            <div className='col-md-4'>
                <label className='fw-Bold'>{Item.FinancialStatementTotalName}</label>
            </div>
            <div className="d-flex col flex-grow-1" >
                <InputGroup className="mx-2">
                    <InputGroup.Text>$</InputGroup.Text>
                    <Form.Control defaultValue={inputValue} className={`${Item.FinancialStatementTypeId}-Total CurrencyText`} id={"txt_" + Item.FinancialStatementTotalName.replace(/[\s(),_/]+/g, '')}  // Formatting the number using thousand separators
                        disabled />
                </InputGroup>

                {
                    subSection?.FinancialStatementTabId !== 3 &&
                    <InputGroup className="mx-2">
                        <InputGroup.Text>%</InputGroup.Text>
                        <Form.Control type="text" className={`${Item.FinancialStatementId}-TextBox-disabled`}
                            defaultValue={pcvalue} disabled id={"txtPC_" + Item.FinancialStatementTotalName.replace(/[\s(),_/]+/g, '')} />

                    </InputGroup>}



                {subSection?.FinancialStatementTabId == 1 &&
                    <><div style={{ width: "20px" }} ></div></>
                }

                {subSection?.FinancialStatementTabId == 2 &&
                    <><div style={{ width: "70px" }} ></div></>
                }

                {subSection?.FinancialStatementTabId == 3 &&
                    <><div style={{ width: "20px" }} ></div>
                        <InputGroup className="mx-1"></InputGroup>
                    </>
                }


            </div>

        </div>
    </>

}

export const AccordionItemStatementTab = ({ TitleName, FinancialDetails, FinancialTotals, subSection, Totaltype, onEdit, setTabData, tabData, saveData }) => {
    const TotalTypes = Totaltype.filter(item => item.FinancialStatementTypeId == subSection.FinancialStatementTypeId);
    return <div className="displaygridDiv" key={subSection.FinancialStatementSectionId + "AccordionDiv"} >
        {FinancialDetails?.map(financialStatementItem => {
            if (financialStatementItem.FinancialStatementTypeId === subSection.FinancialStatementTypeId) {

                return (
                    <div key={financialStatementItem.FinancialStatementId + "Fields"}>
                        <EachQElementStatementTab TitleName={TitleName} financialStatementItem={financialStatementItem} FinancialTotals={FinancialTotals} FinancialDetails={FinancialDetails} onEdit={onEdit} setTabData={setTabData} tabData={tabData} saveData={saveData} />
                    </div>
                )
            }
        })}
        {TotalTypes?.map((TItem) => {
            return <div key={subSection.FinancialStatementTypeId + "Total"} className={subSection.FinancialStatementTypeId + "TotalDiv"}>
                <TotalItem Item={TItem} FinancialTotals={FinancialTotals} subSection={subSection} />
            </div>
        })}
    </div>
}

// Investment Tab accordion
export const AccordionItemInvestTab = ({ TitleName, InvestmentDetails, subSection, FinancialTotals, onEdit, setTabData, tabData, saveData }) => {
    return <div className="displaygridDiv" key={subSection.FinancialStatementSectionId + "AccordionDiv"} >
        {InvestmentDetails?.map(investmentDetailItem => {
            if (investmentDetailItem.FinancialStatementTypeId === subSection.FinancialStatementTypeId) {
                return (
                    <div key={investmentDetailItem.FinancialStatementInvestmentId + "Fields"}>
                        <EachQElementInvestTab TitleName={TitleName} investmentDetailItem={investmentDetailItem} InvestmentDetails={InvestmentDetails} FinancialTotals={FinancialTotals} onEdit={onEdit} setTabData={setTabData} tabData={tabData} saveData={saveData} />
                    </div>
                )
            }
        })}
        {FinancialTotals?.map((TItem) => {
            if (TItem.FinancialStatementTypeId == subSection.FinancialStatementTypeId)
                return <div key={subSection.FinancialStatementTypeId + "Total"} className={subSection.FinancialStatementTypeId + "TotalDiv"}>
                    <TotalItem Item={TItem} FinancialTotals={FinancialTotals} subSection={subSection} />
                </div>
        })}

    </div>
}

//Investment tab
const InvestmentTab = ({ FinancialTotal, FormattedSections, FinancialStTypes, TabID, financialStInvestData, onEdit, tabData, setTabData, saveData }) => {
    const [securitymodal, setsecuritymodal] = useState(false);
    const [securityName, setsecurityName] = useState();
    const dispatch = useDispatch();
    const showsecurityModal = () => {
        setsecuritymodal(true);
    }
    const closesecurityModal = () => {
        setsecuritymodal(false);
    }

    const txtsecurityNameChange = (event) => {
        setsecurityName(event.target.value);
    }


   

    const SaveSecurities = () => {

        let saveSuccess = true;
        let errorMsg = [];
        if (!securityName) {
            saveSuccess = false;
            errorMsg.push("Security Name is Required");
        }


        if (saveSuccess) {
            sbaAxios({
                url: `${InsertSecurity}${securityName}`,
                method: 'get',
            })
                .then((response) => {
                    if (response >= 0)
                        SBNotify({ Msg: 'Security Added Successfully', type: 'success' });
                    else
                        SBNotify({ Msg: 'Security Name Already Exist', type: 'warning' });
                    setsecuritymodal(false);
                })
                .catch((error) => {
                    console.error(error);
                });
        }
        else {
            let ErrorString = "";
            errorMsg.map(item => { ErrorString = `${ErrorString}${item} \n` });
            console.log(errorMsg);
            toast.error(ErrorString, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
        }
    }
    return <>
        {FormattedSections?.map(section => {
            if (section.TabID == TabID && section.FinancialStatementSectionId !== 0)
                return <div key={section.FinancialStatementSectionId} className='my-3'>
                    <div className='my-2 d-flex w-100'>
                        <h5 className='fw-Bold'>
                            {section.FinancialStatementSectionName || "Summary"}
                        </h5>
                        <button className='p-sm-btn ms-auto' onClick={showsecurityModal}> Add Secuirities</button>
                    </div>

                    {FinancialStTypes?.map(subSection => {
                        if (subSection.FinancialStatementSectionId == section.FinancialStatementSectionId) {
                            return <div key={subSection.FinancialStatementTypeId} className='p-1'>
                                <AccordionTab tittle={subSection.FinancialStatementTypeName} TypeId={subSection.FinancialStatementTypeId} TabId={TabID} TabData={tabData} saveData={saveData}>
                                    <AccordionItemInvestTab TitleName={subSection.FinancialStatementTypeName} InvestmentDetails={financialStInvestData} subSection={subSection} FinancialTotals={FinancialTotal} onEdit={onEdit} setTabData={setTabData} tabData={tabData} saveData={saveData} />
                                </AccordionTab>
                            </div>
                        }
                    })
                    }
                </div>
        })}
        <Modal show={securitymodal} >
            <Modal.Header closeButton onClick={closesecurityModal}>
                <Modal.Title>Security Name</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <div>
                        <label className="label">Security Name</label>
                    </div>
                    <div>
                        <input className="form-control w-75" type="text" onChange={txtsecurityNameChange}></input>


                    </div>

                </div>

            </Modal.Body>
            <Modal.Footer>
                <button className="s-sm-btn mx-1" onClick={closesecurityModal}> Cancel</button>
                <button className='p-sm-btn mx-1' onClick={SaveSecurities}>
                    Save
                </button>
            </Modal.Footer>

        </Modal>
    </>

}
